import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

export const IdleWarning = () => {
  const { t } = useTranslation();
  return <Typography variant="h3">{t("Awaiting Data")}</Typography>;
};
